export function validateEmail(email) {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(email);
}

export function validatePhone(phone) {
  if (!phone) return true; // optional field
  const pattern = /^[\d\s()+-]{7,20}$/;
  return pattern.test(phone);
}

export function validateName(name) {
  return name && name.trim().length >= 2;
}
